import * as React from 'react';
import { useGetTimberClassQuery } from "../../../apis/TimberClass.api";
import { PrimaryTimberClass, TimberClass } from "../../../types/models/TimberClass";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: TimberClass;
};

export const TimberClassNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const TimberClassName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetTimberClassQuery(PrimaryTimberClass.fromId(id))
    return (<TimberClassNameDisplay data={data}/>)
}

export default TimberClassName;
